import {
  Component,
  EventEmitter,
  Input,
  Output
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { BadgeCellComponent }      from '../table/cell-components/badge-cell.component';
import { HaynesProLaborTimeModel } from './typings/haynes-pro.labor-time';
import { PushPopComponent }        from '../table/cell-components/actions/push-pop.component';
import { Table }                   from '../table/types/table';

@Component({
  selector   : 'wor-haynes-pro-labor-times',
  template: require('./haynes-pro.labor-times.component.html')
})
export class HaynesProLaborTimesComponent {
  private selections   : Array<HaynesProLaborTimeModel> = [];
  public tableSettings : Table;

  @Input() times    : Array<HaynesProLaborTimeModel> = [];
  @Input() viewMode : boolean;

  @Output() onTimeAdd    : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();
  @Output() onTimeRemove : EventEmitter<HaynesProLaborTimeModel> = new EventEmitter();

  constructor (
    private translateService  : TranslateService
  ) {}

  ngOnInit () : void {
    this.tableSettings = {
      columns: this.buildColumns(),
      empty  : {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND', {
          type: this.translateService.instant('GENERAL_SPACE.FIELD.LABOUR_TIMES')
        })
      },
      pagination: {
        enabled: false
      },
      sorting: {
        enabled: false
      },
      static: true
    };
  }

  buildColumns() {
    const columns:any = [
      {
        field : 'name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.NAME')
        }
      }
    ];

    if (this.times.some(row => row.oe_code?.trim())) {
      columns.push({
        field : 'oe_code',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.OE_CODE')
        },
        classes  : [ 'text-left' ],
        component: {
          bindings: {
            inputs: {
              field: 'oe_code',
              type : 'primary'
            }
          },
          enabled: true,
          factory: BadgeCellComponent,
        },
        sortable: false,
      });
    }

    columns.push({
      field : 'labour_time',
      header: {
        text: this.translateService.instant('GENERAL_SPACE.FIELD.LABOUR_TIME')
      },
    });

    if (!this.viewMode) {
      columns.push({
        classes  : [ 'text-right' ],
        component: {
          bindings: {
            inputs: {
              popTitle : this.translateService.instant('GENERAL_SPACE.BUTTON.REMOVE_FROM_CART'),
              pushTitle: this.translateService.instant('GENERAL_SPACE.BUTTON.ADD_TO_CART'),
            },
            outputs: {
              onPop : ( time : HaynesProLaborTimeModel ) => this.handleTimeRemoval(time),
              onPush: ( time : HaynesProLaborTimeModel ) => this.handleTimeAddition(time)
            }
          },
          enabled: true,
          factory: PushPopComponent,
        },
        sortable: false,
      });
    }

    return columns;
  };

  findSelection ( item : HaynesProLaborTimeModel, selection : HaynesProLaborTimeModel ) : boolean {
    return selection.subgroup_id === item.subgroup_id
      && selection.name === item.name;
  }

  handleTimeAddition ( time : HaynesProLaborTimeModel ) : void {
    this.selections.push(time);

    this.onTimeAdd.emit(time);
  }
  handleTimeRemoval ( time : HaynesProLaborTimeModel ) : void {
    this.removeSelection(time);
  }

  removeSelection ( time : HaynesProLaborTimeModel ) : void {
    this.selections = this.selections.filter(selection => this.findSelection(time, selection));

    this.onTimeRemove.emit(time);
  }
}
